// eslint-disable-next-line no-restricted-imports
import { CountryFragment } from 'api/generated/graphql';
import { parseCountryEntity } from 'api/helpers/parseCountryEntity';
import { RepresentativeClientInfoEntity } from 'api/types/entity';
import { Maybe } from 'types/maybe';

interface RepresentativeClientInfoApi {
  firstName: string;
  lastName: string;
  middleName?: Maybe<string>;
  email: string;
  phoneNumber?: Maybe<string>;
  basisForRepresentation?: Maybe<{
    dateOfExpiration?: Maybe<string>;
  }>;
  residentialAddress?: Maybe<{
    country?: Maybe<CountryFragment>;
  }>;
  registrationAddress?: Maybe<{
    country?: Maybe<CountryFragment>;
  }>;
}

export const parseRepresentativeClientInfoEntity = (
  data: RepresentativeClientInfoApi
): RepresentativeClientInfoEntity => ({
  firstName: data.firstName,
  lastName: data.lastName,
  middleName: data.middleName ?? undefined,
  email: data.email,
  phone: data.phoneNumber ?? undefined,
  basisForRepresentation: {
    dateOfExpiration: data.basisForRepresentation?.dateOfExpiration
      ? new Date(data.basisForRepresentation.dateOfExpiration)
      : undefined,
  },
  residentialAddress: {
    country: data.residentialAddress?.country
      ? parseCountryEntity(data.residentialAddress.country)
      : undefined,
  },
  registrationAddress: data.registrationAddress
    ? {
        country: data.registrationAddress.country
          ? parseCountryEntity(data.registrationAddress.country)
          : undefined,
      }
    : undefined,
});
